module.exports = __webpack_public_path__ + "static/media/des3.cf6af739.jpg";